import { NgModule } from '@angular/core';
import { NkSidebarComponent } from './sidebar.component';

@NgModule({
 imports: [
    NkSidebarComponent
  ],
  exports: [NkSidebarComponent],
})
export class NkSidebarModule {}
